import { ArrowRight } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
import { CompactStepsDemo } from '../progress/CompactStepsDemo';
import { Code } from './Section';
export function CompactStepsTile() {
  const navigate = useNavigate();
  return (
    <div className="overflow-hidden rounded-lg border border-line bg-card">
      <header className="flex flex-wrap items-center gap-4 border-b border-line p-5">
        <div className="min-w-0 flex-1">
          <h3 className="type-heading">Шаги строками</h3>
          <p className="mt-1 text-sm text-fg-muted">
            Компактный вариант для длинной проверки: единый контейнер, связанный ряд статусов и подробности
            внутри строки.
          </p>
        </div>
        <Link
          to="/design/progress/compact"
          className="inline-flex h-9 items-center gap-2 rounded-md border border-line bg-muted px-3 text-xs font-semibold text-fg hover:bg-hover focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none"
        >
          Открыть образец
          <ArrowRight className="size-4" />
        </Link>
      </header>
      <div className="p-5">
        <CompactStepsDemo scope="gallery" onEntityOpen={(id) => navigate('/design/progress/object/' + id)} />
      </div>
      <p className="border-t border-line p-4">
        <Code>LiveStepList variant="compact"</Code>
      </p>
    </div>
  );
}
